// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"151371b1","231":"3784e62e","642":"92217bf4","681":"ac939c55","807":"2399ebcd","827":"a5b7b087","879":"67201f43","880":"9828d29a","943":"46de3b44"}[chunkId] + ".chunk.js";
};